.buttons {
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
}

.button {
  height: 64px;
}

@media all and (--reefer-media-tablet-min) {
  .buttons {
    grid-template-columns: repeat(4, 1fr);
  }
}
